import { NextSeoProps } from "next-seo";
import { getBaseUrl } from "./lib/env";
import { APPLICATION_BASE_PATH } from "./lib/next/config";

const BASE_URL = `${getBaseUrl()}${APPLICATION_BASE_PATH}`;

export const defaultSeoConfig: NextSeoProps = {
  title: "JSONata Playground - Get familiar with the JSONata language",
  description:
    "Get familiar with JSONata syntax in Stedi's playground where you can quickly edit, share, and embed examples.",
  canonical: `https://www.stedi.com${APPLICATION_BASE_PATH}`,
  openGraph: {
    site_name: "Stedi",
    type: "website",
    images: [
      {
        url: `${BASE_URL}/opengraph.png`,
        width: 2400,
        height: 1260,
        alt: "JSONata Playground",
        type: "image/png",
      },
    ],
  },
  twitter: {
    handle: "@stedi",
    cardType: "summary_large_image",
  },
  additionalLinkTags: [
    {
      rel: "icon",
      href: `${BASE_URL}/favicon.ico`,
    },
  ],
};
